// 3-5-8: the game length the player picked in the Games window (owner 2026-10-28: "daj wybór przed rozpoczęciem", a
// drop-down list like Mahjong's shapes). Kept in the browser (a long game's New game reloads the page).
import { DEFAULT_LENGTH, LENGTHS } from '../358/rules';

const KEY = 'solitaire_storage:358-length';

export function picked358Length(): number {
  try {
    const n = Number(localStorage.getItem(KEY));
    return (LENGTHS as readonly number[]).includes(n) ? n : DEFAULT_LENGTH;
  } catch {
    return DEFAULT_LENGTH;
  }
}

export function pick358Length(n: number): void {
  try {
    localStorage.setItem(KEY, String(n));
  } catch {
    // no storage (a private window): the pick lasts until the page reloads
  }
}
